import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WebService\SearchInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/SearchInShutterStockController.php
* @route '/api/webservice/shutterstock/search'
*/
const SearchInShutterStockController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchInShutterStockController.url(options),
    method: 'get',
})

SearchInShutterStockController.definition = {
    methods: ["get","head"],
    url: '/api/webservice/shutterstock/search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WebService\SearchInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/SearchInShutterStockController.php
* @route '/api/webservice/shutterstock/search'
*/
SearchInShutterStockController.url = (options?: RouteQueryOptions) => {
    return SearchInShutterStockController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WebService\SearchInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/SearchInShutterStockController.php
* @route '/api/webservice/shutterstock/search'
*/
SearchInShutterStockController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchInShutterStockController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebService\SearchInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/SearchInShutterStockController.php
* @route '/api/webservice/shutterstock/search'
*/
SearchInShutterStockController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SearchInShutterStockController.url(options),
    method: 'head',
})

export default SearchInShutterStockController